import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo/SKAI_INTEELIGENCE_logo_white.svg";
import { useTranslation } from "react-i18next";
import i18n from "../../locale/i18n";
import { useState } from "react";
import Menu from "../../assets/images/icMenu.png";
import Close from "../../assets/images/icClose.png";

const AppHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [menuVisible, setMenuVisible] = useState(false);
  const changeLanguage = (lang) => {
    localStorage.setItem("lang", lang);
    window.location.reload();
  };
  return (
    <div className="app-header">
      <div className="content">
        <div className="logo-wrap">
          <Link to="/">
            <img src={Logo} alt="logo" />
          </Link>
        </div>
        <div className="menu-wrap">
          <Link to="/about">{t(`appHeader.AboutUs`)}</Link>
          <Link to="/solution">{t(`appHeader.OurSolution`)}</Link>
          <Link to="/aigc-work">{t(`appHeader.Portfolio`)}</Link>
          {/* <Link to="/news">{t(`appHeader.News`)}</Link> */}
          <Link to="/contact">{t(`appHeader.ContactUs`)}</Link>
        </div>
        <div className="lang-wrap">
          <button
            className={i18n.language === "ko" ? "active" : ""}
            onClick={() => changeLanguage("ko")}
          >
            KOR
          </button>
          <div className="block" />
          <button
            className={i18n.language === "en" ? "active" : ""}
            onClick={() => changeLanguage("en")}
          >
            ENG
          </button>
        </div>
        <div className="mobile-wrap">
          <button onClick={() => setMenuVisible(true)}>
            <img src={Menu} alt="" />
          </button>
        </div>
        {menuVisible && (
          <div className="mobile-menu-wrap">
            <div className="header-wrap">
              <div className="logo-wrap">
                <Link
                  onClick={() => {
                    navigate("/");
                    setMenuVisible(false);
                  }}
                >
                  <img src={Logo} alt="logo" />
                </Link>
              </div>
              <div className="lang-wrap">
                <button
                  className={i18n.language === "ko" ? "active" : ""}
                  onClick={() => changeLanguage("ko")}
                >
                  KOR
                </button>
                <div className="block" />
                <button
                  className={i18n.language === "en" ? "active" : ""}
                  onClick={() => changeLanguage("en")}
                >
                  ENG
                </button>
              </div>
              <div className="mobile-wrap">
                <button onClick={() => setMenuVisible(false)}>
                  <img src={Close} alt="" />
                </button>
              </div>
            </div>
            <div className="item-wrap">
              <div
                className="item"
                onClick={() => {
                  navigate("/about");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.AboutUs`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  navigate("/solution");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.OurSolution`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  navigate("/aigc-work");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.Portfolio`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  navigate("/news");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.News`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  navigate("/contact");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.ContactUs`)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppHeader;
